// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"0":"2c763f84","39":"c90bfd5c","379":"e09ac2b4","466":"8928ebcc","511":"d97e61b9","787":"87a6bad6"}[chunkId] + ".chunk.js";
};